<div class="justup-dialog-large detail-dialog">
  @if (ligne(); as l) {
    <header class="detail-header">
      <div class="title-row">
        <h2 class="title">{{ l.ligneDenomination }}</h2>
        <vl-chips [state]="stateChipState()" size="small">{{ stateLabel() }}</vl-chips>
      </div>
      <button mat-icon-button (click)="close()" matTooltip="Fermer" type="button" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="detail-body">
      <!-- Bandeau OF actif -->
      @if (l.currentOf) {
        <section class="of-banner up-2 border-12 p-16 bg-background">
          <div class="of-numero subheading-2">{{ l.currentOf.numero }}</div>
          <div class="of-article body-1 strong">{{ l.currentOf.articleDenomination ?? '—' }}</div>
          @if (l.currentOf.conducteurs?.length) {
            <div class="conducteurs caption on-background-alt">
              <mat-icon>person</mat-icon>
              @for (c of l.currentOf.conducteurs; track c.userInfosId) {
                <span class="conducteur-tag">{{ c.denomination ?? c.initiales }}</span>
              }
            </div>
          }

          <!-- Progress bar -->
          <div class="progress-row">
            <div class="progress-wrap">
              <div class="progress" [style.width.%]="progressPct()"></div>
            </div>
            <div class="progress-label">
              <span class="qty-current strong">{{ l.currentOf.quantiteProduite | number:'1.0-0':'fr-FR' }}</span>
              <span class="qty-sep on-disabled">/</span>
              <span class="qty-target on-background-alt">{{ l.currentOf.quantite | number:'1.0-0':'fr-FR' }}</span>
              @if (l.currentOf.uniteVente) {
                <span class="qty-unit on-background-alt">{{ l.currentOf.uniteVente }}</span>
              }
              <span class="qty-percent strong">({{ progressPct() | number:'1.0-0':'fr-FR' }} %)</span>
            </div>
          </div>
        </section>
      } @else {
        <section class="of-banner up-2 border-12 p-16 bg-background flex-row align-center gap-12">
          <mat-icon class="muted">inbox</mat-icon>
          <span class="body-1 on-background-alt">Aucun OF actif sur cette ligne.</span>
        </section>
      }

      <!-- Mesures machine (uniquement si automate) -->
      @if (hasMachine()) {
        <section class="machine-section">
          <h3 class="section-title subheading-2">Mesures machine</h3>

          <div class="kpi-grid">
            <div class="kpi-card up-2 border-12 p-16 bg-background" [class.kpi-empty]="cadenceInst() == null">
              <div class="kpi-label caption on-background-alt">Cadence instantanée</div>
              <div class="kpi-value title">
                <vl-chips [state]="cadenceChipState()" size="big">{{ cadenceInst() ?? '—' }}</vl-chips>
                <span class="kpi-unit caption on-background-alt">u/h</span>
              </div>
              @if (l.cadenceCibleUH) {
                <div class="kpi-sub caption on-background-alt">
                  Cible · <span class="strong">{{ l.cadenceCibleUH }} u/h</span>
                </div>
              }
            </div>

            <div class="kpi-card up-2 border-12 p-16 bg-background">
              <div class="kpi-label caption on-background-alt">Cadence moyenne</div>
              <div class="kpi-value title">
                <span>{{ cadenceMoy() ?? '—' }}</span>
                <span class="kpi-unit caption on-background-alt">u/h</span>
              </div>
              <div class="kpi-sub caption on-background-alt">
                Depuis le démarrage de l'OF
              </div>
            </div>

            <div class="kpi-card up-2 border-12 p-16 bg-background">
              <div class="kpi-label caption on-background-alt">Sans arrêt</div>
              <div class="kpi-value title">{{ dureeSansArretLabel() }}</div>
              <div class="kpi-sub caption on-background-alt">Durée courante</div>
            </div>

            <div class="kpi-card up-2 border-12 p-16 bg-background">
              <div class="kpi-label caption on-background-alt">Total arrêt</div>
              <div class="kpi-value title">{{ dureeTotaleArretLabel() }}</div>
              <div class="kpi-sub caption on-background-alt">
                {{ cadence()?.nbArrets ?? 0 }} arrêt(s)
              </div>
            </div>
          </div>

          <!-- Sparkline cadence -->
          <div class="spark-card up-2 border-12 p-16 bg-background">
            <div class="caption on-background-alt">Cadence sur les 3 dernières minutes</div>
            @if (sparkPath()) {
              <svg viewBox="0 0 600 80" class="spark-svg" preserveAspectRatio="none">
                <path [attr.d]="sparkPath()" fill="none"
                      [attr.stroke]="cadenceVsCible() === 'high' ? 'var(--color-valid)'
                        : cadenceVsCible() === 'mid' ? 'var(--color-warning)'
                        : cadenceVsCible() === 'low' ? 'var(--color-error)'
                        : 'var(--color-on-disabled)'"
                      stroke-width="2"/>
              </svg>
            } @else {
              <div class="spark-empty caption on-disabled">
                Pas encore de données — patientez quelques secondes.
              </div>
            }
          </div>
        </section>
      } @else {
        <section class="machine-section no-machine">
          <div class="up-2 border-12 p-16 bg-background flex-row gap-12 align-center">
            <mat-icon class="muted">router</mat-icon>
            <div class="flex-col">
              <span class="body-1">Cette ligne n'a pas d'automate connecté.</span>
              <span class="caption on-background-alt">
                Ajoutez un device IoT à la ligne pour voir les mesures live (cadence, arrêts, défauts).
              </span>
            </div>
          </div>
        </section>
      }

      <!-- Actions -->
      <footer class="detail-actions">
        @if (l.currentOf) {
          <vl-big-button text="Ouvrir l'OF" icon="open_in_new"
                         color="secondary"
                         (action)="openOf()"/>
        }
        @if (l.reportId) {
          <vl-big-button text="Pilotage machine"
                         icon="precision_manufacturing"
                         color="primary"
                         (action)="openMachineDashboard()"/>
        }
      </footer>
    </div>
  } @else {
    <div class="loading-empty">
      <mat-icon>hourglass_empty</mat-icon>
      <span class="body-1">Chargement…</span>
    </div>
  }
</div>
